import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCalendarAlt, faDollarSign, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_cotizacion: '',
        id_version: '',
        id_cod_dpto: '',
        id_cod_mpio: '',
        tipo_valor: '',
        inv_inicial: '',
        inv_final: '',
        fecha_ini: '',
        fecha_fin: '',
        resolucion:'',
        periodo:'',
        id_estado_cotizacion: '1',
        estado_cotizacion: '',
        utilidad: '',proyecto: '' ,alcance: '',
        departamentos: [],
        municipios: [],
        errores: [],
        Periodos:[]
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { id_cod_dpto,resolucion, id_cod_mpio, tipo_moneda, inv_inicial, inv_final, fecha_ini, fecha_fin, id_estado_cotizacion,utilidad,proyecto ,alcance,periodo} = this.state;
        var errores = [];
        if (!id_cod_dpto) { errores.push("error_id_cod_dpto"); }
        if (!id_cod_mpio) { errores.push("error_id_cod_mpio"); }
        if (!tipo_moneda) { errores.push("error_tipo_moneda"); }
        if (!inv_inicial) { errores.push("error_inv_inicial"); }
        if (!inv_final) { errores.push("error_inv_final"); }
        if (!fecha_ini) { errores.push("error_fecha_ini"); }
        if (!fecha_fin) { errores.push("error_fecha_fin"); }
        //if (!utilidad) { errores.push("error_utilidad"); }
        if (!proyecto) { errores.push("error_proyecto"); }
        if (!alcance) { errores.push("error_alcance"); }
        if (!resolucion) { errores.push("error_resolucion"); }

        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            id_cod_dpto: id_cod_dpto,
            id_cod_mpio: id_cod_mpio,
            tipo_moneda: tipo_moneda,
            valor_moneda: window.localStorage.getItem("valorDolar"),
            inv_inicial: inv_inicial,
            inv_final: inv_final,
            fecha_ini: fecha_ini,
            fecha_fin: fecha_fin,
            utilidad: 0,
            proyecto: proyecto,
            alcance: alcance,
            periodo:periodo,
            resolucion:resolucion,
            id_estado_cotizacion: id_estado_cotizacion,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("cotizaciones/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Cotizaciones!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.setState({ id_cotizacion: datosRespuesta.data.id_cotizacion, id_version: datosRespuesta.data.id_version })
                    this.props.history.push("/UpCotizaciones/" + datosRespuesta.data.id_cotizacion);
                } else {
                    Swal.close();
                    Swal.fire(
                        'Cotizaciones!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_cod_dpto = document.getElementById("id_cod_dpto").value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_cod_dpto)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                window.$("#id_cod_mpio").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    PeriodosIpp() {

  
        authAxios.get("ipp/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Periodos: datosRespuesta.data.data, load: '' });
                window.$("#id_cod_mpio").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        this.PeriodosIpp();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { id_cotizacion,Periodos, id_version, departamentos, municipios, tipo_valor, id_cod_dpto, id_cod_mpio, inv_inicial, inv_final, fecha_ini, fecha_fin, id_estado_cotizacion,utilidad,proyecto ,alcance, periodo } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE COTIZACIONES</b>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div class="card">
                                            <div className="card-header text-center">
                                                <b>INFORMACIÓN BÁSICA COTIZACIÓN</b>
                                            </div>
                                            <div class="card-body">
                                                <form onSubmit={this.enviarDatos}>
                                                    <div className="row">
                                                        <div className="col-xl-12">
                                                            <div className='row g-3'>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="id_cod_dpto">Departamento</label>
                                                                    <select name="id_cod_dpto"
                                                                        id="id_cod_dpto"
                                                                        className={((this.verificarError("error_id_cod_dpto")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={e => {
                                                                            this.cargarMunicipios(e);
                                                                            this.cambioValor(e)
                                                                        }}>
                                                                        <option value="">Seleccione el Departamento</option>
                                                                        {
                                                                            departamentos.map((itemDepartamentos) => (
                                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="id_cod_mpio">Municipio</label>
                                                                    <select name="id_cod_mpio" id="id_cod_mpio"
                                                                        className={((this.verificarError("error_id_cod_mpio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={this.cambioValor}>
                                                                        <option value="">Seleccione el Municipio</option>
                                                                        {
                                                                            municipios.map((itemMunicipios) => (
                                                                                <option key={itemMunicipios.ID_MUNICIPIO} value={itemMunicipios.ID_MUNICIPIO}>{itemMunicipios.NOMBRE}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="resolucion">Tipo Resolución</label>
                                                                    <select name="resolucion"
                                                                        id="resolucion"
                                                                        className={((this.verificarError("error_resolucion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={this.cambioValor}>
                                                                        <option value="">Seleccione la resolucion</option>
                                                                        <option value="123">CREG 123</option>
                                                                        <option value="101">CREG 101</option>
                                                                    </select>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo resolucion</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="estado_cotizacion">Estado Cot.</label>
                                                                    <input type="hidden" id="id_estado_cotizacion" name="id_estado_cotizacion" value={id_estado_cotizacion} />
                                                                    <input style={{ textTransform: 'uppercase', backgroundColor: '#0D6EFD', color: '#FFFFFF', fontWeight: 'bold' }} className={((this.verificarError("error_estado_cotizacion")) ? "is-invalid" : "") + " form-control form-control-sm text-center"} type="text" name="estado_cotizacion" id="estado_cotizacion" value="EN PROCESO" placeholder="Estado Cotización" aria-describedby="helpId" onChange={this.cambioValor} readOnly />
                                                                    <small id="helpId" className="invalid-feedback">Digite el Estado Cot.</small>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="tipo_moneda">Tipo Moneda</label>
                                                                    <select name="tipo_moneda"
                                                                        id="tipo_moneda"
                                                                        className={((this.verificarError("error_tipo_moneda")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={this.cambioValor}>
                                                                        <option value="">Seleccione el Tipo Moneda</option>
                                                                        <option value="COL">En Pesos (COL)</option>
                                                                        <option value="USD">En Dolares (USD)</option>
                                                                        <option value="EUR">En Euro (EUR)</option>
                                                                    </select>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Moneda</small>
                                                                </div>
                                                            {/*     <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Utilidad</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad" value={utilidad}
                                                                                className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad de la obra" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite la Utilidad de la obra</small>
                                                                    </div> */}
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Proyecto</label>
                                                                        <div className="input-group input-group-sm">
                                                                         
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="proyecto" id="proyecto"value={proyecto}
                                                                                className={((this.verificarError("error_proyecto")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre del proyecto" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite el nombre del proyecto</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Alcance</label>
                                                                        <div className="input-group input-group-sm">
                                                                           
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="alcance" id="alcance" value={alcance}
                                                                                className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Alcance del proyecto" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite el alcance</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Periodo</label>
                                                                        <div className="input-group input-group-sm">
                                                                        <select name="periodo" id="periodo"
                                                                        className={((this.verificarError("error_periodo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={this.cambioValor}>
                                                                        <option value="">Seleccione el periodo</option>
                                                                        {
                                                                            Periodos.map((itemMunicipios) => (
                                                                                <option key={itemMunicipios.id} value={itemMunicipios.name_select}>{itemMunicipios.name_select}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite el alcance</small>
                                                                    </div>
                                                            </div>
                                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="inv_inicial">Inversión Inicial</label>
                                                                    <div class="input-group input-group-sm">
                                                                        <span class="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_inv_inicial")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="inv_inicial" id="inv_inicial" value={inv_inicial} placeholder="Inversión Inicial" aria-describedby="helpId" onChange={this.cambioValor} />
                                                                    </div>
                                                                    <small id="helpId" className="invalid-feedback">Digite la Inversión Inicial</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="inv_final">Inversión Final</label>
                                                                    <div class="input-group input-group-sm">
                                                                        <span class="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_inv_final")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="inv_final" id="inv_final" value={inv_final} placeholder="Inversión Final" aria-describedby="helpId" onChange={this.cambioValor} />
                                                                    </div>
                                                                    <small id="helpId" className="invalid-feedback">Digite la Inversión Final</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="fecha_ini">Fecha Inicial</label>
                                                                    <div class="input-group input-group-sm">
                                                                        <span class="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_fecha_ini")) ? "is-invalid" : "") + " form-control form-control-sm"} type="date" name="fecha_ini" id="fecha_ini" value={fecha_ini} placeholder="Fecha Inicial" aria-describedby="helpId" onChange={this.cambioValor} />
                                                                    </div>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Inicial</small>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <label htmlFor="fecha_fin">Fecha Final</label>
                                                                    <div class="input-group input-group-sm">
                                                                        <span class="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_fecha_fin")) ? "is-invalid" : "") + " form-control form-control-sm"} type="date" name="fecha_fin" id="fecha_fin" value={fecha_fin} placeholder="Fecha Final" aria-describedby="helpId" onChange={this.cambioValor} />
                                                                    </div>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Final</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className='row'>
                                                        <div className='col-xl-12 text-center'>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Cotización</button>&nbsp;&nbsp;
                                                                <Link className="btn btn-danger btn-sm" to={"/MasterCotizaciones"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-5">
                                        <div class="card">
                                            <div className="card-header text-center">
                                                <b>COTIZACIÓN # <span style={{ fontSize: 13 }} className="badge bg-secondary">{id_cotizacion}</span> - VERSIÓN <span style={{ fontSize: 13 }} className="badge bg-secondary">{id_version}</span></b>
                                            </div>
                                            <div class="card-body">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;